/* eslint-disable react-hooks/exhaustive-deps */
import { get } from 'lodash'
import React, { useEffect, useState } from 'react'
import { modifyClientBalance } from '../../../apis/bond-debts'
import Form from '../../../components/Form'
import Modal, { ModalHeader } from '../../../components/Modal'
import useForm from '../../../hooks/useForm'
import { viewLoading } from '../../../utils/loading'
import systemAlert from '../../../utils/systemAlert'

const BondDebtBaseAmt = ({ open, setOpen, data, setData, submit }) => {
  const [fields] = useState([
    [
      {
        title: '기초잔액',
        key: 'balance',
        type: 'input',
        required: true,
        validators: ['comma']
      }
    ],
  ])

  useEffect(() => {
    setForm({
      balance: String(get(data, "client.bondDebtBaseAmt", "0"))
    })
  }, [data])

  const _submit = (form) => {
    systemAlert(`${get(data, 'client.name')}의 기초잔액을 반영하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            viewLoading(true)
            modifyClientBalance(data.clientIdx, form)
              .then((res) => {
                submit()
                cancel()
              })
              .catch(() => { })
              .finally(() => {
                viewLoading(false)
              })
          }
        }
      ]
    })
  }

  useEffect(() => {
    setValidateFields(fields)
  }, [fields])

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    setValidateFields
  } = useForm(
    {
      balance: "",
    },
    _submit,
  );

  const cancel = () => {
    setOpen(false)
    setData(null)
  }

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="bond-debt-banlance-write">
        <ModalHeader>{`${get(data, 'client.name')} 기초잔액`}</ModalHeader>
        <Form
          fields={fields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  )
}

export default BondDebtBaseAmt